module.exports = __webpack_public_path__ + "media/styles/images/svg/course-teal-aaaaf3093117e6d8b33d75507aad64b3.svg";